import React, { useState } from "react";
import Card from "../../MyUI/Card/Card";
import EditableForm from "../../MyUI/EditableForm/EditableForm";
import { validateRows } from "../../MyUI/EntityTableTemplate/validateEntity";
import { createUser_MyProfile } from '../../../services/services';
import { Link, useNavigate, useParams } from "react-router-dom";

export default function SignUpPage() {

const navigate = useNavigate();

const genders = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Non-binary", value: "Non-binary" },
  { label: "Prefer not to say", value: "Prefer not to say" },
  { label: "Self-describe", value: "Self-describe" },
];


  const formFields=[
    {key: "username", label: "Full Name", type: "input", validation: ["required"] },
    {key: "email", label: "Email", type: "email", validation: ["required", "email"] },
    {key: "gender", label: "gender(optional)", type: "select", SELECT_OPTIONS:genders, placeholder:'choose your gender'  },
    {key: "phone_number", label: "phone_number(optional)", type: "input", validation: ["phone_number"] },
    {key: "password", label: "password", type: "password", validation: ["required"] },
    {key: "password2", label: "confirm password", type: "password" , validation: ["required"]},
    {key: "pass_phrase", label: "passphrase", type: "input", validation: ["required"] },
    {key: "address", label: "address", type: "input" },
  ];
  const [formParams, setFormParams] = useState([{}]);
  
  const idField = "id";
  const services= {
      create: createUser_MyProfile,
      services_url_names: {
      create: "createUser_MyProfile",
      },
    }
  
  return (
    <Card title={"Registration"} showChevron={false}>
       <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
        <h2 style={{marginBottom: "50px"}}>Registration</h2>
        {/* EditableForm rendered directly */}
        <EditableForm
          isNotScrollable={true}
          params={formParams}
          setParams={setFormParams}
          validateRows={validateRows}
          state="create"
          title={"Sign up"}
          columns={formFields}
          services={services}       
          idField={idField}         
          refParam={null}   
          saveButtonName={"Send Verification Email"}
          onClose={() => {navigate("/ConnectionPopUp");}}
          onSaved={(f) => {}}
        />

      </div>
    </Card>
  );
}
